import React, { useEffect, useState } from 'react'
import schoolLogo from '../Assets/founder1.jpg' // left photo
import schoolLogo2 from '../Assets/founder2.jpeg' // right photo
import Logo from '../Assets/founder2.jpeg' // right photo
import './HomePage.css'
import axios from 'axios'
import { Modal, Input, Form, Button } from 'antd'
import { toast } from 'react-toastify'
import {
  ForgotPassword,
  RegistrationAPI,
  ResetPasswordAPI,
  StudentLoginAPI,
} from '../AllAPI/StudentAPI'
import { useNavigate } from 'react-router-dom'
import { AdminLoginAPI } from '../AllAPI/AdminAPI'
import { EyeInvisibleOutlined,MobileOutlined, EyeTwoTone, PhoneOutlined, UserOutlined, SafetyOutlined, MailOutlined } from '@ant-design/icons'
import DaniSir from '../Assets/DaniSir.jfif'
import AloneMadam from '../Assets/AloneMadam.jfif'
import MahabaleshwarwalaSir from '../Assets/MahabaleshwarwalaSir.jfif'
import MalameSir from '../Assets/MalameSir.jfif'
import MaliSir from '../Assets/MaliSir.jfif'
import ParamaneSir from '../Assets/ParamaneSir.jfif'
import SamudreSir from '../Assets/SamudreSir.jfif'
import UserPhoto from '../Assets/User.jfif'

export default function HomePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  // ------------------- Disable Back Button -------------------
  useEffect(() => {
    // Push a dummy state
    window.history.pushState(null, null, window.location.href)

    const handlePopState = () => {
      // Push forward again
      window.history.pushState(null, null, window.location.href)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])
  // ===================================================================

  const navigate = useNavigate()
  const [openRegister, setOpenRegister] = useState(false)
  const [openLogin, setOpenLogin] = useState(false)
  const [openAdminLogin, setOpenAdminLogin] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const [regStudentFName, setRegStudentFName] = useState('')
  const [regStudentMName, setRegStudentMName] = useState('')
  const [regStudentLName, setRegStudentLName] = useState('')
  const [regMobile, setRegMobile] = useState('')
  const [regEmail, setRegEmail] = useState('')
  const [regPassword, setRegPassword] = useState('')
  const [regConfirmPassword, setRegConfirmPassword] = useState('')

  const [loginPassword, setLoginPassword] = useState('')
  const [loginUserId, setLoginUserId] = useState('')

  const [adminLoginPassword, setAdminLoginPassword] = useState('')
  const [adminLoginUserId, setAdminLoginUserId] = useState('')

  const [showRegSuccessModal, setShowRegSuccessModal] = useState(false)

  const [registerLoading, setRegisterLoading] = useState(false)
  const [loginLoading, setLoginLoading] = useState(false)
  const [adminLoginLoading, setAdminLoginLoading] = useState(false)
  const [alreadyRegisteredModal, setAlreadyRegisteredModal] = useState(false)
  const [registrationRejectedModal, setRegistrationRejectedModal] = useState(
    false,
  )

  const [openForgotModal, setOpenForgotModal] = useState(false)
  const [forgotMobile, setForgotMobile] = useState('')
  const [forgotLoading, setForgotLoading] = useState(false)

  const [openResetModal, setOpenResetModal] = useState(false)
  const [resetMobile, setResetMobile] = useState('')
  const [resetOtp, setResetOtp] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [resetLoading, setResetLoading] = useState(false)

  const [form] = Form.useForm()

  const clearFields = () => {
    setOpenRegister(false)
    setRegStudentFName('')
    setRegStudentMName('')
    setRegStudentLName('')
    setRegMobile('')
    setRegEmail('')
    setRegPassword('')
    setRegConfirmPassword('')
  }

  const handleRegister = async (e) => {
    e.preventDefault()

    if (
      !regStudentFName ||
      !regStudentMName ||
      !regStudentLName ||
      !regMobile ||
      !regEmail ||
      !regPassword ||
      !regConfirmPassword
    ) {
      return toast.error('All fields are required')
    }

    if (!/^[0-9]\d{9}$/.test(regMobile)) {
      return toast.error('Enter valid 10-digit mobile number')
    }

    if (regPassword.length < 4) {
      return toast.error('Password must be at least 4 characters')
    }

    if (regPassword !== regConfirmPassword) {
      return toast.error('Passwords do not match')
    }

    try {
      setRegisterLoading(true)
      const body = {
        fname: regStudentFName,
        mname: regStudentMName,
        lname: regStudentLName,
        mobile: regMobile,
        email: regEmail,
        password: regPassword,
      }

      const response = await axios.post(RegistrationAPI, body)

      if (response.data === 'SAVED') {
        toast.success('Registration Successful!')
        setShowRegSuccessModal(true)
        clearFields()
      } else if (response.data === 'EMAILEXIST') {
        toast.warn('Email Already Exist! Try with another one')
      } else if (response.data === 'MOBEXIST') {
        toast.warn('Mobile No. Already Exist! Try with another one')
      } else {
        toast.error('Some Error Occurred! Please try again')
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration Failed')
    }
    setRegisterLoading(false)
  }

  const handleLogin = async (e) => {
    e.preventDefault()

    if (!loginUserId || !loginPassword) {
      return toast.error('Enter User ID & Password')
    }

    try {
      setLoginLoading(true)

      const body = {
        mobile: loginUserId,
        password: loginPassword,
      }

      const response = await axios.post(StudentLoginAPI, body)

      if (response.data === 'REQUIRED') {
        toast.warn('Required Fields!')
      } else if (response.data === 'INVALID') {
        toast.error('Invalid Data!')
      } else if (response.data.member_id !== null) {
        // Clear input fields
        setLoginUserId('')
        setLoginPassword('')

        // 👉 Check status and take action
        if (response.data.status === 0) {
          navigate('/terms-condition') // status 1 → go to terms page
          toast.success('Login Successful!')
          // Save response in sessionStorage
          sessionStorage.setItem('userData', JSON.stringify(response.data))
        } else if (response.data.status === 1) {
          toast.warn('Plase wait for admin approval..!')
        } else if (response.data.status === 2) {
          setAlreadyRegisteredModal(true)
        } else if (response.data.status === 3) {
          setRegistrationRejectedModal(true)
        }

        setOpenLogin(false)
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login Failed')
    }

    setLoginLoading(false)
  }

  const handleAdminLogin = async (e) => {
    e.preventDefault()

    if (!adminLoginUserId || !adminLoginPassword) {
      return toast.error('Enter User ID & Password')
    }

    try {
      setLoginLoading(true)

      const body = {
        username: adminLoginUserId,
        password: adminLoginPassword,
      }

      const response = await axios.post(AdminLoginAPI, body)

      if (response.data === 'REQUIRED') {
        toast.warn('Required Fields!')
      } else if (response.data === 'NOTFOUND') {
        toast.warn('Invalid Data!')
      } else if (response.data == 'ADMINLOGIN') {
        // Clear input fields
        setAdminLoginUserId('')
        setAdminLoginPassword('')

        // 👉 Check status and take action
        if (response.data !== null) {
          navigate('/admin/dashboard')
          toast.success('Login Successful!')
          // Save response in sessionStorage
          sessionStorage.setItem('userData', JSON.stringify(response.data))
        }
        setOpenAdminLogin(false)
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login Failed')
    }

    setAdminLoginLoading(false)
  }

  const handleForgotPassword = async () => {
    if (forgotMobile.length !== 10) {
      toast.error('Please enter valid 10 digit mobile number')
      return
    }

    try {
      setForgotLoading(true)

      const response = await axios.post(ForgotPassword, {
        mobile: forgotMobile,
      })
      if (response.data == 'SENDOTP') {
        toast.success('Password reset OTP sent successfully')
        setOpenForgotModal(false)

        // set mobile to reset modal
        setResetMobile(forgotMobile)

        // open reset password modal
        setOpenResetModal(true)

        setForgotMobile('')
      }
    } catch (error) {
      toast.error('Mobile number not registered')
    } finally {
      setForgotLoading(false)
    }
  }

  const handleResetPassword = async () => {
    if (!resetOtp || !newPassword) {
      toast.error('All fields are required')
      return
    }

    try {
      setResetLoading(true)

      const response = await axios.post(ResetPasswordAPI, {
        mobile: resetMobile,
        otp: resetOtp,
        newPassword: newPassword,
      })

      if (response.data === 'PASSWORDCHANGED') {
        toast.success('Password reset successfully')
        setOpenResetModal(false)
        setResetOtp('')
        setNewPassword('')
      } else if (response.data === 'REQUIRED') {
        toast.error('Data Required!')
      } else if (response.data === 'NOTFOUND') {
        toast.error('Data Not Found!')
      } else if (response.data === 'INVALIDOTP') {
        toast.error('Invalid OTP!')
      } else if (response.data === 'EXPIRYOTP') {
        toast.error('Your OTP has expired. Please request a new one.')
      } else {
        toast.error('Some error occurred ! Please try again')
      }
    } catch (error) {
      toast.error('Something went wrong')
    } finally {
      setResetLoading(false)
    }
  }

  const thStyle = {
    border: '1px solid #000',
    padding: '8px',
    backgroundColor: '#fac1c1ff',
    fontWeight: 'bold',
  }

  const tdStyle = {
    border: '1px solid #000',
    padding: '8px',
  }

   const tdStyle1 = {
    width:"150px",height:"130px",border:"1px solid gray",borderRadius:"5px"
  }

  return (
    <div className="home-container">
      {/* Top Header */}
      <div className="top-header">
        <img src={schoolLogo} alt="Left Logo" className="school-logo" />

        <h1 className="school-title">श्री वारणा विद्यालय, वारणानगर</h1>

        <img src={schoolLogo2} alt="Right Logo" className="school-logo1" />
      </div>

      <div className="btn-row">
        <button className="custom-btn" onClick={() => setOpenRegister(true)}>
          Register
        </button>
        <button className="custom-btn" onClick={() => setOpenLogin(true)}>
          Login
        </button>
      </div>

      {/* Heading */}
      <p className="main-heading">सुवर्ण महोत्सव</p>
      <p className="main-heading1">महामैत्र मेळा २०२६</p>

      {/* Information */}
       <div className="row m-0">
          <div className='col-12 col-md-3'></div>
          <div className='col-12 col-md-6'>
              <div className="info-box p-0">
                <p>नमस्कार,</p>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  आपल्या शाळेची सुरुवात ऋषीतुल्य सहकार महर्षी, के. तात्यासाहेव कोरे
                  यांच्या प्रेरणेतून ९ जून १९६९ साली झाली. द्रूढ इच्छाशक्ती एकच होती...
                  ती म्हणजे महाराष्ट्रातील एक उत्कृष्ठ शाळा तयार करायची. शाळा उत्कृष्ठ
                  बनवायची असेल तर त्या शाळेला एका चांगल्या प्राचार्याची गरज लागणार हे
                  ओळखून शोधा शोध सुरू केली व त्यातूनच एक अवलीया तात्यांना सापडले त्यांचे
                  नाव प्राचार्य महाबळेश्वरवाला सर. कै. तात्यासाहेब व कै. महाबळेश्वरवाला
                  सर यांच्या मार्गदर्शनाखाली <b>'श्री वारणा विद्यालय'</b> या नावाचे एक
                  रोपटे वाढण्यास सुरुवात झाली. बघता-बघता या रोपट्याचे आता वटवृक्षात
                  रूपांतर झाले. हे वटवृक्ष २०२० साली पन्नास वर्षाचे झाले. या
                  सुवर्णक्षणासाठी पुन्हा आपण सर्वजण या वटवृक्षाच्या सावलीत{' '}
                  <b> दिनांक २४ व २५ जानेवारी २०२६</b> रोजी मुक्कामी एकत्र येत आहोत..
                </p>
                <p>
                  {' '}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  या ५० वर्षांमध्ये आपल्या विद्यालयातून जवळपास १५५७० विदयार्थी शिक्षण
                  घेवून बाहेर पडले आहेत. या सर्व विद्यार्थ्यांच्या काही ना काही आठवणी
                  आहेत. त्या फक्त त्यांच्या वर्गातील मुलांच्या ग्रुपमध्येच आहेत. या
                  आठवणी सर्व विद्यार्थ्यांपर्यंत पोहचवण्यासाठी व आपल्या शिक्षकांचे अनुभव
                  सर्वांना वाचण्यासाठी <b>"माझ्या जीवनावर शाळेचा झालेला परिणाम"</b> या
                  नैसर्गिक भावना आपण लेखी स्वरूपात व्यक्त कराव्यात. तसेच आपल्या काही
                  जुन्या आठवणी, वसतीगृहातुन पाठवलेली पत्रे किंवा इतर आठवणी आपण लेखी
                  स्वरुपात अंतिम तारखेपूर्वी समितीकडे पाठवाव्या. समिती मार्फत आपण एक
                  स्मरणिका तयार करणार आहोत सर्वांच्याच आठवणी आपल्या या स्मरणिकेमध्ये
                  समाविष्ठ करण्याचा प्रयत्न राहिल. त्यासाठी मा. देशपांडे सर यांच्या
                  मार्गदर्शनाखाली आपण एक समिती स्थापन केली आहे. जे काही लेख समितीकडे
                  येतील त्यातील निवडक लेख स्मरणिकेमध्ये समाविष्ठ करण्यात येतील. अशा
                  अस्मरणीय व बहुमुल्य स्मरणिकेमध्ये आपण आपल्या व्यवसाय, उ‌द्योगाची
                  जाहिरात देवून सहकार्य करावे ही विनंती.
                </p>
                <div className="text-end">
                  <p>आपले नम्र,</p>
                  <p>
                    <b>श्री वारणा विद्यालय सुवर्ण महोत्सव नियोजन समिती</b>
                  </p>
                </div>
              </div>
          </div>
          <div className='col-12 col-md-3'></div>
      </div>

      {/* Table */}
      <div className="row m-0 mt-3">
        <div className='col-12 col-md-3'></div>
        <div className='col-12 col-md-6'>
          <div>
            {/* Table Title */}
            <h5
              style={{
                textAlign: 'center',
                marginBottom: '10px',
                fontWeight: 'bold',
                backgroundColor: '#ffb10a',
                padding: '10px',
              }}
            >
              श्री वारणा विद्यालय वारणानगर, प्राचार्य कार्यकाळ
            </h5>
          </div>

          <div className='mb-3'  style={{
                overflowX:"auto",
              }}>
            <table
              className="shadow"
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                textAlign: 'left',
              }}
            >
              <thead>
                <tr>
                  <th style={thStyle}>अनु.क्र</th>
                  <th style={thStyle}>नाव</th>
                  <th style={thStyle}>पासून</th>
                  <th style={thStyle}>पर्यंत</th>
                  <th style={thStyle}>फोटो</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tdStyle}>1</td>
                  <td style={tdStyle}>कै. वि स खोचीकर</td>                 
                  <td style={tdStyle}>9 जून 1969</td>
                  <td style={tdStyle}>31 मे 1972</td>
                   <td style={tdStyle}>
                    <img src={UserPhoto} alt="कै. वि स खोचीकर" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>2</td>
                  <td style={tdStyle}>कै. बा धो सूर्यवंशी</td>                   
                  <td style={tdStyle}>1 जून 1972</td>
                  <td style={tdStyle}>3 जून 1973</td>
                  <td style={tdStyle}>
                    <img src={UserPhoto} alt="कै. बा धो सूर्यवंशी" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>3</td>
                  <td style={tdStyle}>कै. ज ना दाणी</td>                  
                  <td style={tdStyle}>4 जून 1973</td>
                  <td style={tdStyle}>31 ऑगस्ट 1973</td>
                  <td style={tdStyle}>
                    <img src={DaniSir} alt="कै. ज ना दाणी" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>4</td>
                  <td style={tdStyle}>कै. साम महाबळेश्वरवाला</td>                    
                  <td style={tdStyle}>1 सप्टेंबर 1973</td>
                  <td style={tdStyle}>31 मे 1986</td>
                  <td style={tdStyle}>
                    <img src={MahabaleshwarwalaSir} alt="कै. साम महाबळेश्वरवाला" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>5</td>
                  <td style={tdStyle}>कै. शि द परमणे</td>                   
                  <td style={tdStyle}>1 जून 1986</td>
                  <td style={tdStyle}>30 जून 1997</td>
                   <td style={tdStyle}>
                    <img src={ParamaneSir} alt="कै. शि द परमणे" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>6</td>
                  <td style={tdStyle}>श्री शा रा समुद्रे</td>                   
                  <td style={tdStyle}>1 जुलै 1997</td>
                  <td style={tdStyle}>31 ऑगस्ट 2008</td>
                   <td style={tdStyle}>
                    <img src={SamudreSir} alt="श्री शा रा समुद्रे" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>7</td>
                  <td style={tdStyle}>सौ स व्य आलोणे</td>                   
                  <td style={tdStyle}>1 सप्टेंबर 2008</td>
                  <td style={tdStyle}>30 एप्रिल 2009</td>
                   <td style={tdStyle}>
                    <img src={AloneMadam} alt="सौ स व्य आलोणे" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>8</td>
                  <td style={tdStyle}>श्री नि पां खामकर</td>                   
                  <td style={tdStyle}>1 मे 2009</td>
                  <td style={tdStyle}>31 मे 2009</td>
                   <td style={tdStyle}>
                    <img src={UserPhoto} alt="श्री नि पां खामकर" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>9</td>
                  <td style={tdStyle}>श्री ग कृ माळी</td>                   
                  <td style={tdStyle}>1 जून 2009</td>
                  <td style={tdStyle}>31 मे 2013</td>
                   <td style={tdStyle}>
                    <img src={MaliSir} alt="श्री ग कृ माळी" style={tdStyle1}/>
                  </td>
                </tr>
                <tr>
                  <td style={tdStyle}>10</td>
                  <td style={tdStyle}>श्री मा बा मलमे</td>                   
                  <td style={tdStyle}>1 जून 2013</td>
                  <td style={tdStyle}>आज अखेर</td>
                   <td style={tdStyle}>
                    <img src={MalameSir} alt="श्री मा बा मलमे" style={tdStyle1}/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
        <div className='col-12 col-md-3'></div>
      </div>

      {/* Footer */}
      <footer className="homeFooter">
        <div className="footer">
          <div className="footer-left">
            <img src={Logo} alt="School Logo" className="footer-logo" />
            <h3 className="school-name">श्री वारणा विद्यालय, वारणानगर</h3>
          </div>
          <div
            className="footer-right text-start"
            style={{ lineHeight: '30px' }}
          >
            <p>
              📍 Address : At Post. Warananagar - 416 113. <br /> Tal.: Panhala,
              Dist. : Kolhapur. Maharashtra. India.
            </p>
            <p>📞 Phone : +91 9422043564, 8381056232, 7028983003</p>
            <p>✉️ Email : shreewaranav@gmail.com</p>
            <button
              className="admin-btn"
              onClick={() => setOpenAdminLogin(true)}
            >
              Admin Login
            </button>
          </div>
        </div>
        <div
          className="row footer-text py-2 text-center m-0"
          style={{ borderTop: '1px solid gray', color: '#b3b1b1ff' }}
        >
          <span>
            © 2025 Shree Warana Vidyalaya, Warananagar — All Rights Reserved.
          </span>
        </div>
      </footer>

      {/* ---------------- REGISTRATION MODAL ---------------- */}
      <Modal
        title="Student Registration"
        open={openRegister}
        onCancel={() => setOpenRegister(false)}
        footer={null}
        width={600}
        className="custom-modal"
      >
        <form className="modal-form" onSubmit={handleRegister}>
          {/* Student Name */}
          <label>Student Name</label>
          <Input
            placeholder="Enter First Name"
            value={regStudentFName}
            onChange={(e) => setRegStudentFName(e.target.value)}
            className="modal-input"
             suffix={
                <UserOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
          />
          <Input
            placeholder="Enter Middle Name"
            value={regStudentMName}
            onChange={(e) => setRegStudentMName(e.target.value)}
            className="modal-input"
             suffix={
                <UserOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
          />
          <Input
            placeholder="Enter Last Name"
            value={regStudentLName}
            onChange={(e) => setRegStudentLName(e.target.value)}
            className="modal-input"
             suffix={
                <UserOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
          />

          {/* Mobile */}
          <label>Mobile Number</label>
          <Input
            placeholder="10 digit mobile number"
            maxLength={10}
            value={regMobile}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, '') // REMOVE all non-digits
              setRegMobile(val)
            }}
            className="modal-input"
             suffix={
                <PhoneOutlined
                  style={{ cursor: 'unset' ,color:"#918f8fff"}}
                />
            }
          />

          {/* Email */}
          <label>Email</label>
          <Input
            placeholder="example@gmail.com"
            value={regEmail}
            onChange={(e) => setRegEmail(e.target.value)}
            className="modal-input"
             suffix={
                <MailOutlined 
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
          />

          {/* Password */}
          <label>Password</label>

          <Input
            size="middle"
            type={showPassword ? 'text' : 'password'}
            placeholder="Re-enter Password"
            value={regPassword}
            onChange={(e) => setRegPassword(e.target.value)}
            className="modal-input"
            suffix={
              showPassword ? (
                <EyeTwoTone
                  onClick={() => setShowPassword(false)}
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => setShowPassword(true)}
                  style={{ cursor: 'pointer' }}
                />
              )
            }
          />

          {/* Confirm Password */}
          <label>Confirm Password</label>
           <Input
            size="middle"
            type={showPassword ? 'text' : 'password'}
            placeholder="Re-enter Password"
            value={regConfirmPassword}
            onChange={(e) => setRegConfirmPassword(e.target.value)}
            className="modal-input"
            suffix={
              showPassword ? (
                <EyeTwoTone
                  onClick={() => setShowPassword(false)}
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => setShowPassword(true)}
                  style={{ cursor: 'pointer' }}
                />
              )
            }
          />

          {/* Submit Button */}
          <button
            className="modal-submit-btn"
            type="submit"
            disabled={registerLoading}
          >
            {registerLoading ? 'Please wait...' : 'Register'}
          </button>
        </form>
      </Modal>

      {/* ====Reg Info==== */}
      <Modal
        title="Registration Completed"
        open={showRegSuccessModal}
        onCancel={() => {}}
        footer={[
          <button
            key="ok"
            className="modal-submit-btn"
            onClick={() => setShowRegSuccessModal(false)}
          >
            OK
          </button>,
        ]}
        maskClosable={false} // cannot close by clicking outside
        closable={false} // no X button at top
      >
        <p>Your registration is completed 🎉</p>
        <p>Please login to access your account.</p>
        <p>After login, please complete the remaining form.</p>
      </Modal>

      {/* ====Already Reg info==== */}
      <Modal
        title="Registration Already Completed"
        open={alreadyRegisteredModal}
        onCancel={() => {}}
        footer={[
          <button
            key="ok"
            className="modal-submit-btn"
            onClick={() => setAlreadyRegisteredModal(false)}
          >
            OK
          </button>,
        ]}
        maskClosable={false} // cannot close by clicking outside
        closable={false} // no X button at top
      >
        <p>You have already registered and payment is completed 🎉</p>
        <p>For any query, Please contact to admin or school management.</p>
      </Modal>

      {/* ====Already Reg info==== */}
      <Modal
        title="Registration Rejected"
        open={registrationRejectedModal}
        onCancel={() => {}}
        footer={[
          <button
            key="ok"
            className="modal-submit-btn"
            onClick={() => setRegistrationRejectedModal(false)}
          >
            OK
          </button>,
        ]}
        maskClosable={false} // cannot close by clicking outside
        closable={false} // no X button at top
      >
        <p>
          Your registration has been <b>Rejected</b> by admin
        </p>
        <p>For any query, Please contact to admin or school management.</p>
      </Modal>

      {/* ----------------STUDENT LOGIN MODAL ---------------- */}
      <Modal
        title="Student Login"
        open={openLogin}
        onCancel={() => setOpenLogin(false)}
        footer={null}
        className="custom-modal"
      >
        <form className="modal-form" onSubmit={handleLogin}>
          <label>Mobile No.</label>

          <Input
            placeholder="10 digit mobile number"
            maxLength={10}
            value={loginUserId}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, '') // REMOVE all non-digits
              setLoginUserId(val)
            }}
            size="middle"
            className="modal-input"
             
             suffix={
                <PhoneOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }            
          />

          <label>Password</label>

           <Input
            size="middle"
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter New Password"
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
            className="modal-input"
            suffix={
              showPassword ? (
                <EyeTwoTone
                  onClick={() => setShowPassword(false)}
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => setShowPassword(true)}
                  style={{ cursor: 'pointer' }}
                />
              )
            }
          />

          <div
            style={{
              textAlign: 'right',
              marginBottom: '12px',
              cursor: 'pointer',
              color: '#1677ff',
              fontSize: '14px',
            }}
            onClick={() => {
              setOpenLogin(false)
              setOpenForgotModal(true)
            }}
          >
            Forgot Password?
          </div>

          <button
            className="modal-submit-btn"
            type="submit"
            disabled={loginLoading}
          >
            {loginLoading ? 'Please wait...' : 'Login'}
          </button>
        </form>
      </Modal>

      {/* ======FORGOT PASSWORD MODAL======= */}
      <Modal
        title="Forgot Password"
        open={openForgotModal}
        onCancel={() => setOpenForgotModal(false)}
        footer={null}
        className="custom-modal"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault()
            handleForgotPassword()
          }}
        >
          <label>Mobile No.</label>

          <Input
            placeholder="Enter registered mobile number"
            maxLength={10}
            value={forgotMobile}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, '')
              setForgotMobile(val)
            }}
            className="modal-input"
             suffix={
                <PhoneOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
          />

          <button
            className="modal-submit-btn"
            type="submit"
            disabled={forgotLoading}
          >
            {forgotLoading ? 'Sending...' : 'Send'}
          </button>
        </form>
      </Modal>

      {/* ======RESET PASSWORD MODAL======= */}
      <Modal
        title="Reset Password"
        open={openResetModal}
        onCancel={() => setOpenResetModal(false)}
        footer={null}
        className="custom-modal"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault()
            handleResetPassword()
          }}
        >
          <label className="pt-2">Mobile No.</label>
          <Input value={resetMobile} disabled className="modal-input"
           suffix={
                <PhoneOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
             />

          <label className="pt-2">OTP</label>
          <Input
            placeholder="Enter OTP"
            maxLength={6}
            value={resetOtp}
            onChange={(e) => setResetOtp(e.target.value.replace(/\D/g, ''))}
            className="modal-input"
             suffix={
                <SafetyOutlined
                  style={{ cursor: 'unset',color:"#918f8fff" }}
                />
            }
          />

          <label className="pt-2">New Password</label>
          <Input
            size="middle"
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="modal-input"
            suffix={
              showPassword ? (
                <EyeTwoTone
                  onClick={() => setShowPassword(false)}
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => setShowPassword(true)}
                  style={{ cursor: 'pointer' }}
                />
              )
            }
          />

          <button
            className="modal-submit-btn"
            type="submit"
            disabled={resetLoading}
          >
            {resetLoading ? 'Updating...' : 'Reset Password'}
          </button>
        </form>
      </Modal>

      {/* ----------------ADMIN LOGIN MODAL ---------------- */}
      <Modal
        title="Admin Login"
        open={openAdminLogin}
        onCancel={() => setOpenAdminLogin(false)}
        footer={null}
        className="custom-modal"
      >
        <form className="modal-form" onSubmit={handleAdminLogin}>
          <label>User ID</label>
          <Input size="middle"
            placeholder="Enter User ID"
            value={adminLoginUserId}
            onChange={(e) => setAdminLoginUserId(e.target.value)}
            className="modal-input"
             suffix={
                <UserOutlined
                  style={{ cursor: 'unset' ,color:"#918f8fff"}}
                />
            }
          />

          <label>Password</label>
          <Input
            size="middle"
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter Password"
            value={adminLoginPassword}
            onChange={(e) => setAdminLoginPassword(e.target.value)}
            className="modal-input"
            suffix={
              showPassword ? (
                <EyeTwoTone
                  onClick={() => setShowPassword(false)}
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => setShowPassword(true)}
                  style={{ cursor: 'pointer' }}
                />
              )
            }
          />

          <button
            className="modal-submit-btn"
            type="submit"
            disabled={adminLoginLoading}
          >
            {adminLoginLoading ? 'Please wait...' : 'Login'}
          </button>
        </form>
      </Modal>
    </div>
  )
}
